/** B2C */
export const ACCOUNT_BOOKINGS_PAGE_NAME = 'account::bookings'
export const ACCOUNT_ACTIVITY_PAGE_NAME = 'account::activity'
export const ACCOUNT_LOYALTY_PAGE_NAME = 'account::loyalty'
export const ACCOUNT_YOUR_PARTNER_BENEFITS_PAGE_NAME = 'account::your partner benefits'
export const ACCOUNT_ALL_SIGNATURE_PLAN_MODIFICATION_PAGE_NAME =
  'account::all signature::plan modification'
export const ACCOUNT_STAY_PREFERENCES_PAGE_NAME = 'account::stay preferences'
export const ACCOUNT_MY_INFORMATION_PAGE_NAME = 'account::my information'

export const ACCOUNT_HUB_SUBSCRIPTION_PAGE_NAME = 'account::hub subscription'
export const ACCOUNT_PROFILE_IDENTITY_DOCUMENTS_PAGE_NAME = 'account::profile::identity documents'
export const SECURITY_SETTINGS_PAGE_NAME = 'account::security settings'

/** AAB */
export const HOMEPAGE_PAGE_NAME = 'loyalty program::all accor business::account::homepage'
export const LOYALTY_PAGE_NAME = 'loyalty program::all accor business::account::loyalty page'
export const BOOKINGS_PAGE_NAME = 'loyalty program::all accor business::account::bookings'
export const TEAM_MANAGEMENT_PAGE_NAME =
  'loyalty program::all accor business::account::team management'
export const COMPANY_SETTINGS_PAGE_NAME =
  'loyalty program::all accor business::account::company settings'
